import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { ButtonActivity, DonationItem, ENVIRONMENT, Environment, Lead, sizeDescriptions } from '@domains';
import { AppService } from '@donor/app.service';
import { FlowService } from '@donor/screens/flow/donor-flow.service';
import { Designable, DesignService, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';
import { take } from 'rxjs';

@Component({
  selector: 'app-item-preview-dialog',
  templateUrl: './item-preview-dialog.component.html',
  styleUrls: ['./item-preview-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    FxLayoutDirective,
    FxLayoutGapDirective,
    MatIcon,
    FxLayoutAlignDirective,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatRadioModule,
  ],
})
export class ItemPreviewDialogComponent extends Designable implements OnInit {
  disassembly: boolean;
  count = 1;
  sizeDescriptions = sizeDescriptions;
  lead: Lead;
  public constructor(
    public reference: MatDialogRef<ItemPreviewDialogComponent>,
    @Inject(ENVIRONMENT) protected environment: Environment,
    @Inject(MAT_DIALOG_DATA) public data: { item: DonationItem; request_id: string },
    protected override designService: DesignService,
    public override responsiveService: ResponsiveService,
    public flowService: FlowService,
    public appService: AppService,
  ) {
    super(designService, responsiveService);
  }

  override ngOnInit(): void {
    this.lead = new Lead(this.flowService.lead);
  }

  removeItem(): void {
    if (this.count > 1) {
      this.count = this.count - 1;
    }
  }

  addItem(): void {
    this.count = this.count + 1;
  }

  handleQuantityChangeThroughInput(event: any) {
    const value = Number(event.target.value.replace(/[^0-9]/g, ''));
    event.target.value = value;

    this.count = value;
  }

  submit(): void {
    if (this.disassembly === true) {
      this.lead.specification.disassembly += this.count;
    }
    const existing = this.lead.aggregatedItems.find((item) => item.item.id === this.data.item.id && item.item.type === 'Item');
    if (existing) {
      existing.count += this.count;
    } else {
      this.lead.aggregatedItems.push({ item: this.data.item, count: this.count });
    }
    this.flowService.updateCart(this.lead).subscribe({
      next: () => {
        this.appService
          .createLeadActivity(this.flowService.lead?.id, ButtonActivity.ITEM_ADDED, this.data.item.id, this.data.request_id)
          .pipe(take(1))
          .subscribe();
        if (this.disassembly === true) {
          this.appService
            .createLeadActivity(this.flowService.lead?.id, ButtonActivity.DISASSEMBLY_ADDED, this.data.item.id, this.data.request_id)
            .pipe(take(1))
            .subscribe();
        }
        this.reference.close(true);
      },
      error: (err) => {
        console.error('Error updating Cart:', err);
      },
    });
  }
}
